import React, { useState } from 'react'
import { sponsorRegistration } from '../../../../../core/data/json/contractFarming';
import ConditionsTable from '../../../Sponsor/Agreement/components/Conditions';
import SponsorAgreementP1 from '../../../Sponsor/Agreement/components/Page1';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
// import { useLocation } from 'react-router-dom';


interface AggrementS {
    reviewedData?: any;
    appdata?: any;
    conditionsData?: any;
    setConditionsData?: any;
    roleIdentifier?: any
}

const MDformO = ({ roleIdentifier, reviewedData, appdata, conditionsData, setConditionsData }: AggrementS) => {

    const [isEnable, setIsEnable] = useState<any>(true);
    const [productDetails, setProductDetails] = useState<any>({});

    interface ConditionItem {
        itemNo: string;
        item: string;
        isBlankExist: boolean;
        blank: any[];
        subItem: {
            subitemNo: string;
            subItemSno: string;
            subItemVal: string;
        }[];
        isTableExist: boolean;
        tableItems: any[];
        isUpdated?: boolean;
        status?: 'normal' | 'deleted' | 'updated' | 'added'; // To change conditons 
    }

    // const [conditionsData, setConditionsData] = useState<ConditionItem[]>(sponsorRegistration);

    const handleNext = () => {
       
    }


    return (
        <div>

            
            <div className='d-flex align-content-center justify-content-between mt-3'>
                {roleIdentifier !== "SPO" &&
                    <p className='m-0 ms-5' style={{ fontSize: "1.25rem" }}>Preview of Agreement Form submitted by Sponsor</p>
                }
                <p></p>
                {(appdata?.Status !== "pending" || appdata?.appStatusLevel == "pendingAtMBMD") ?
                    (
                        reviewedData?.buttonName &&
                        <button className='me-5 btn btn-outline-secondary' onClick={() => {
                            setIsEnable(!isEnable);
                            if (!isEnable) {
                                toast.info("Edit mode disabled", { position: "top-right" });

                            } else {
                                toast.success("Edit mode enabled", { position: "top-right" });
                            }
                        }} >
                            {isEnable ? 'Edit Enable' : 'Edit Disable'}
                        </button>
                    ) :
                    ('')
                }

            </div>
            <SponsorAgreementP1
                onNext={handleNext}
                conditionsData={conditionsData}
                setConditionsData={setConditionsData}
                reviewedData1={appdata?.Sponsor_Id && reviewedData}
                appdata1={appdata}
                isEnable1={isEnable}
                setProductDetails={setProductDetails && setProductDetails}
            />
        </div>
    )
}

export default MDformO